import { createLogger } from "redux-logger";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

export const createRouterMiddleware = () => routerMiddleware(history);

export const createLoggerMiddleware = () => {
  const isProdBuild = process.env.NODE_ENV === "production";
  const isTestBuild = process.env.NODE_ENV === "test";

  return createLogger({
    predicate: () => !isProdBuild && !isTestBuild
  });
};
